module.exports = __webpack_public_path__ + "img/monochrom-logo.ad45cc6e.svg";